import { createTheme } from '@mui/material/styles';
import colors from './assets/CollorPallet.module.scss';

const theme = createTheme({
  palette: {
    primary: {
      main: colors.primaryColor,
    },
    secondary: {
      main: colors.secondaryColor,
    },
    error: {
      main: colors.errorColor,
    },
    success: {
      main: colors.successColor,
    },
  },
});

export default theme;
